<template>
  <div class="q-py-xl">
    <div class="text-center text-primary text-weight-bold" style="font-size: 2.75rem">
      Real-time data & analytics for your portfolio
    </div>
    <div class="text-center text-grey-7 q-mb-xl text-subtitle1">
      Leverage daily data and insights from more than 5 million multifamily properties and gain an
      edge on your competition
    </div>
  </div>
  <div class="subscribe-market-analytics">
    <checkout-card
      plan-name="Market Analytics Add-On"
      :price="price"
      :promo-formatted-price="formattedPrice"
      :trial-days="0"
      add-on
      @create-subscription="createSubscription"
    >
      <div>
        <div>
          <div class="text-weight-medium">Activate Market Analytics Add-On</div>
          <div class="text-grey-9">{{ formattedPrice }}</div>
        </div>
      </div>
    </checkout-card>
  </div>
</template>

<script lang="ts">
import { useStripeStore } from '@/stores/stripe'
import CheckoutCard from '@/components/CheckoutCard.vue'

export default {
  name: 'SubscribeMarketAnalyticsView',
  components: {
    CheckoutCard
  },
  computed: {
    price() {
      return useStripeStore().billedPerSeat ? 200 : 0.2
    },
    formattedPrice() {
      return useStripeStore().billedPerSeat ? '$200/user/month' : '$0.20/unit/month'
    }
  },
  methods: {
    async createSubscription(payload: {
      paymentId: string
      couponId?: string
      cb: () => void
      failCb: () => void
    }) {
      const sub = await useStripeStore().createMarketAnalyticsSubscription()
      if (sub) {
        payload.cb()
      } else {
        payload.failCb()
      }
    }
  }
}
</script>
<style scoped>
.subscribe-market-analytics {
  max-width: 1280px;
  margin: auto;
}
</style>
